module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAABHNCSVQICAgIfAhkiAAAAKNJREFUGFeF0LttQkEQheFvUkQjRBYNoBvRBtABboBHAQjoAMdOyF2EjUQXIMhIFy13hS4IiyNNsDv/ztkz4UmJPXrBqdmKF+ABneD4ACZW+A2+ciNxBxMVBsEoymFWM+b4Rh8TdDEOtnfrxBBrtHDBMsgDbnoG8zfaBVxE7VCDxXpaHo3xU6zz3Qc+b9YlzF+w+SfMMMj1qGbqd3vcoQrOTfAKGOMvC+DD90gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_star.png
// module id = 317
// module chunks = 7